import React from 'react'
import styled from 'styled-components'

/**
 * A styled div component with flex display.
 * The flex direction is determined by the `direction` prop.
 */
const FlexStyle = styled.div(({ direction }) => ({
  display: 'flex',
  flexDirection: direction === 'vertical' ? 'column' : 'row',
}))

/**
 * Flex component to render children in a flex container.
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The children to be rendered inside the flex container.
 * @param {'horizontal' | 'vertical'} props.direction - The direction of the flex container.
 * @param {React.CSSProperties} [props.style] - Optional style object to customize the component.
 * @returns {JSX.Element} Flex container with children elements.
 */
const Flex = ({ children, direction, ...props }) => {
  return (
    <FlexStyle direction={direction} {...props}>
      {children}
    </FlexStyle>
  )
}

export default Flex
